import { deleteCookie, getCookie, setCookie } from 'utils/cookie';

const PARTY_ID = 'party_id';

export const setPartyId = (partyId: number) => setCookie(PARTY_ID, partyId.toString());

export const removePartyId = () => deleteCookie(PARTY_ID);

export const getPartyId = () => getCookie(PARTY_ID);
